import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'app-about-us',
  imports: [
    NgOptimizedImage,
    NgxTolgeeModule,
  ],
  templateUrl: './about-us.component.html'
})
export class AboutUsComponent {

}
